import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2CEcom = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />

			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/b2c-ecommerce-website-development.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2C E-Commerce Website Development
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2C E-Commerce Website Development
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					B2C E-Commerce Website Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2c2-ecommerce.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								A B2C E-Commerce Module is a place where all the transactions
								take place directly between an organisation and an end consumer.
								In the B2C E-Commerce portal, customer comes to the website,
								search a product as per their requirements, choose the products
								and make order of the product. After placing an order, seller
								receives an email or a notification alert in his/her dashboard
								for the order and after confirming this order from seller
								customer also receives a confirmation email from seller. After
								receiving the order, goods are dispatched to the buyer’s
								delivery address.
							</p>
							<br />
							<p>
								Most of the E-Commerce companies that sell goods directly to end
								users can be referred to as B2C companies. Now this is time
								requirement to all these B2C store to start their online portal
								because in this internet era, everyone wants to purchase goods
								or services online through their smartphone or PC without
								wasting his money or time on travelling or waiting at the store.
							</p>

							<br />
							<p>
								Arya Aviation provides a platform where a customer can feel free
								and explore all the items which were added by admin. Our B2C
								E-Commerce Module is advance technology enabled which helps you
								to achieve your goals. Advance search filter allows the user to
								fetch the data and display desired results. After selecting the
								category or by custom search, the customers can easily search
								for the items all over on the website and can buy or gift to
								someone by selecting the mode of payment like credit card, debit
								card through Payment Gateway or can be placed order by COD (If
								seller allow). Our Artificial Intelligence based system not only
								helps the user to choose the product but also saves their time
								by making quick and easy order place process.
							</p>

							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default B2CEcom;
